// extracted by mini-css-extract-plugin
export default {"page":"OAuthAuthorize_page__NDfxd","card":"OAuthAuthorize_card__ttF8m","actions":"OAuthAuthorize_actions__XudRu"};